// F5 : filtres de la carte et du dashboard. `etats` est la Map<pavId, état> d'`etatsDesPav`.

// `commune` = CLÉ de commune (index.communes[].cle), pas la graphie brute.

/** Ids de patrimoines couverts par une liste de jetons : ids (nombre ou chaîne) ou groupe `intra` / `extra`. */
export function patrimoinesRetenus(index, jetons) {
    const ids = new Set();
    for (const jeton of jetons || []) {
        if (jeton === 'intra' || jeton === 'extra') {
            for (const p of index.patrimoineById.values()) {
                if (p.groupe === jeton) ids.add(p.id);
            }
        } else {
            ids.add(Number(jeton));
        }
    }
    return ids;
}

export function filtrerPavs(index, etats, filtres, {inclureRetires = false} = {}) {
    const {patrimoines = [], commune = '', etats: verdicts = [], element = ''} = filtres || {};
    const ids = patrimoinesRetenus(index, patrimoines);
    const res = [];
    for (const pav of index.pavs) {
        if (!inclureRetires && pav.statut === 'RETIRÉ') continue;
        if (!ids.has(pav.patrimoineId)) continue;
        if (commune && pav.communeCle !== commune) continue;
        const etat = etats.get(pav.id);
        if (verdicts.length > 0 && !verdicts.includes(etat.verdict)) continue;
        if (element && !etat.elementsEnDefaut.includes(element)) continue;
        res.push(pav);
    }
    return res;
}
